import React from 'react';
import { Link } from 'react-router-dom'

export class OverdueReplenishments extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            overdueReplenishments: 0
        };
    }

    componentDidMount() {
        this.props.fetchData().then((response) => {
            const data = response.data;
            this.setState({overdueReplenishments: data.totalElements})
        });
    }

    render() {
        return (
            <div className="card">
                <div className="card-body p-3 d-flex align-items-center">
                    <i className="fa fa-warning bg-danger p-3 font-2xl mr-3"></i>
                    <div>
                        <div className="text-value-sm text-danger" style={{fontWeight: "bold", fontSize: "large"}}>
                            {this.state.overdueReplenishments}
                        </div>
                        <div className="text-muted text-uppercase font-weight-bold small">
                            <Link to="/admin/replenishment" onClick={this.props.showDetails}>überfällige Nachversorgungen</Link>
                        </div>
                    </div>
                </div>
                {/*<div className="card-footer px-3 py-2">*/}
                    {/*<a className="btn-block text-muted d-flex justify-content-between align-items-center"*/}
                       {/*href="#">*/}
                        {/*<span className="small font-weight-bold">Details anzeigen</span>*/}
                        {/*<i className="fa fa-angle-right"></i>*/}
                    {/*</a>*/}
                {/*</div>*/}
            </div>
        );
    }
}

export default OverdueReplenishments;


// WEBPACK FOOTER //
// ./src/admin/dashboard/Widgets/OverdueReplenishments.js